import { TextField } from "@mui/material";
import { useEffect, useRef } from "react";
import { useAi } from "src/context/AiContext";
import { useUserData } from "src/context/userContext";

export default function AiLayout_Prompt() {
  const { ownerAsiakasId, token } = useUserData();
  const { prompt, setPrompt, response, isLoading, handleSubmit } = useAi();

  const textFieldRef = useRef(null);

  useEffect(() => {
    textFieldRef.current?.focus();
  }, [response]);

  const handleKeyDown = async (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      await handleSubmit(ownerAsiakasId, token);
    }
  };

  return (
    <TextField
      label={response.length > 0 && "Miten voin auttaa?"}
      value={prompt}
      onChange={(e) => setPrompt(e.target.value)}
      onKeyDown={handleKeyDown}
      fullWidth
      multiline
      maxRows={20}
      size="small"
      variant="filled"
      inputRef={textFieldRef}
      disabled={isLoading}
    />
  );
}
